/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:43:48
 */
const s = {
    ballDistance: 16.5,
    diameter: 6.24,
    numRows: 16,
    yMult: 1.12,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [202.90262206726462, 223.83267859396662, 224.591656626686, 226.30704586517342, 202.88928735248658, 201.04646055691418, 203.44201072784378, 201.0562112122842],
        1: [203.36810374738832, 226.09020582079575, 202.3444631307251, 204.155995372076, 201.85350262580442, 203.54516180992619, 203.4455586013711, 225.75422807339112],
        2: [224.95421619258028, 224.19758968214416, 202.92998085654622, 227.2744584694529, 204.0137476849266, 203.30172405797893, 226.40065598193334, 225.63540236832154],
        3: [223.86150964436752, 201.46167770794125, 225.6716064920891, 227.29641583000083, 223.87512122863353, 204.06238674419302, 225.50193021572233, 201.31503285380546],
        4: [225.46399901022943, 226.1131617538378, 226.87785769701532, 225.62978758254894, 204.2085661073375, 204.28002943998527, 226.86854082212867, 201.05881373565765],
        5: [203.35626580873245, 203.94910875783705, 203.44181786758233, 203.6462359173024, 223.9458359054582, 201.0359860928008, 202.26854425169742, 226.85234595031986],
        6: [226.0283622219575, 201.9594646169491, 225.62917874248424, 202.01525667606657, 225.22321978840122, 203.73709432877288, 204.59802096286282, 224.59809442372105],
        7: [226.06924054232297, 204.55147025135068, 201.19851439469875, 224.9687608494576, 225.63961239352722, 203.6817340819391, 202.76566294143723, 224.5065156978038],
        8: [202.3368156695958, 203.71871222719307, 224.48675558370147, 200.91080989018107, 203.87178652541434, 202.81048547100286, 224.9333405216616, 204.3683090170654],
        9: [201.16158595162068, 225.9549965201327, 203.80268907595433, 226.08669014440343, 223.70722492239463, 201.71737433589718, 226.55355003962754, 225.6848088602706],
        10: [225.92309415380916, 226.14868632674086, 203.3699193295997, 224.81563750708406, 201.6058225578752, 224.7437846175704, 204.10617254311705, 224.06935511794111],
        11: [224.17404900543633, 223.38322210830063, 201.05816879587346, 203.21312773492699, 203.99016972610895, 201.6196152593616, 204.26276316814472, 226.90455509311764],
        12: [203.38888367897917, 227.3026412211604, 223.54929950407015, 203.75410072719743, 226.68828587009742, 225.10850831588712, 202.76510344538661, 226.90577297219363],
        13: [226.8304103390249, 223.906632464166, 225.9092647097804, 224.19018537080998, 223.92816355197644, 225.7767545926227, 224.26874815761704, 226.4991848488229],
        14: [201.19457281921166, 223.44734597628064, 202.9707317410267, 202.38302542365378, 223.9830384379456, 224.63225306472188, 225.96910330520384, 224.66306222424876],
        15: [204.46560449472582, 223.53442965437463, 224.57216517958915, 203.48814015173818, 200.72585169888958, 223.38431696209807, 201.2120534859606, 224.52804275756628],
        16: [226.843887811095, 225.383527930157, 203.32441628367084, 226.90117980028904, 226.22577041215789, 226.8767261546192, 203.9275681654095, 223.89879799086384],
        17: []
    }
};
export {s as default};
